export enum HrocChecklistsQueryKey {
  ChecklistTemplates = 'checklist-templates',
  Checklists = 'checklists',
  ChecklistDoneForTemplate = 'checklist-done-for-template',
  SupervisorUserSearch = 'supervisor-user-search'
}
